import React from 'react';
import { Card } from './ui/card';
import { Waves, Sparkles, Flame, Heart } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Waves: Waves,
  Sparkles: Sparkles,
  Flame: Flame,
  Heart: Heart
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-emerald-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Signature Experiences That Define Us
          </h2>
          <p className="text-lg text-gray-600">
            Beyond venues and decor, we craft moments of magic. From sacred rituals 
            to wellness journeys, every detail is infused with Rishikesh's spiritual essence.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="overflow-hidden hover:shadow-2xl transition-all duration-300 border border-gray-200 group"
              >
                <div className="grid md:grid-cols-2 h-full">
                  {/* Image */}
                  <div className={`relative overflow-hidden h-64 md:h-auto ${index % 2 === 0 ? 'md:order-1' : 'md:order-2'}`}>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  </div>

                  {/* Content */}
                  <div className={`p-8 flex flex-col justify-center ${index % 2 === 0 ? 'md:order-2' : 'md:order-1'}`}>
                    <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                      <IconComponent size={24} className="text-amber-700" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Additional Services List */}
        <div className="mt-16 bg-white rounded-3xl p-8 md:p-12 shadow-lg max-w-5xl mx-auto">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Complete Wedding Services
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            {[
              'Mandap Design & Setup',
              'Photography & Videography',
              'Makeup & Styling',
              'Multi-Cuisine Catering',
              'DJ & Live Music',
              'Guest Accommodation',
              'Transportation',
              'Mehendi & Sangeet',
              'Pandit & Rituals',
              'Floral Decorations',
              'Lighting & Sound',
              'Welcome Gift Hampers'
            ].map((service, idx) => (
              <div key={idx} className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
                <span className="text-gray-700">{service}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
